<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' Carihareket kayıt işlemleri için, '" v-model="loadingvmodel"></loadingcomp>

    <v-form>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap py-0>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{ $t('Add-Current-Transaction') }} &nbsp; {{ekbaslik}}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <v-btn :disabled="!sayfayetki.Save && carihareketview" v-if="butongorunum" slot="activator"
                  @click="checkData()" flat> <span class="hidden-sm-and-down"> {{$t("save_button")}}
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t('Add-Current-Transaction') }}</span>
              </v-tooltip>


              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <a target="_self" v-bind:href="'#/carihareketler/index'">
                    <v-list-tile>
                      <v-list-tile-title> {{ $t('Action-List') }} </v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-layout v-if="carihareketview" row wrap>

            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>
                      <v-form ref="formbiletrapor" v-model="valid" lazy-validation>
                        <caricomp v-bind:statecariyedek="caricompitems" v-bind:zorunlumu="true"
                          v-model="Movement.Current" @sendCurrentInfo="getCurrentInfo($event)"></caricomp>

                        <tarihcomp :etiket="$t('Date')" :detaygizle="true" v-model="Movement.MovementDate"
                          :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'"></tarihcomp>
                        <tarihcomp :etiket="$t('Maturity-Date')" :detaygizle="true" v-model="Movement.MovementDueDate"
                          v-bind:defaultvalue="'ok'"></tarihcomp>
                        <v-autocomplete :items="EvrakTipi1" hide-details="" v-bind="EvrakTipi1" item-text="Title"
                          item-value="Evrakkod" :rules="[v => !!v || $t('Please-select-v2')]" v-model="Movement.DocumentType"
                          :label="$t('Document-Type')"></v-autocomplete>
                        <v-text-field hide-details="" @blur="makbuztipkontrol()" rows="10px" :label="$t('Document-No')"
                          v-model="Movement.DocumentNumber" maxlength="16">
                        </v-text-field>
                        <v-select :items="states1" hide-details="" :label="$t('Debit-Credit')" item-text="text"
                          item-value="value" v-model="Movement.DebitCredit" :rules="[v => !!v || $t('Please-select-v2')]"
                          clearable></v-select>
                      </v-form>
                      <parainput :name="tutar"  :simge="getparabirimi()"   :error-messages="errors.collect('tutar')" v-model="Movement.Amount"
                        :etiket="etikettutar" data-vv-name="tutar" required v-validate="'required'" :id="tutar"
                        :autocomplete="autocomplete" @input="tutarHesapla()"></parainput>
                      <v-textarea :label="$t('Description')" v-model="Movement.Explanation" maxlength="500" value=""></v-textarea>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout justify-space-between column>


                      <muhasebekoducomp v-if="PB=='TRY'" :etiket="$t('Accounting-Code')"  v-model="Movement.ContraAccount"></muhasebekoducomp>


                        <bankakodu  v-model="Movement.BankCode"></bankakodu>

                      <kredikartcomp v-model="Movement.FirmCardNumber"> </kredikartcomp>
                      <v-layout>
                        <v-flex xs12 sm6 md6>
                          <v-autocomplete :items="bankapositems" hide-details="" v-model="Movement.PosCode"
                            @change="taksitgetir(Movement.PosCode)" item-text="Title" item-value="PosKodu" clearable
                            :label="$t('Pos-Code')"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6 md6>
                          <v-select v-if="PB=='TRY'" :items="taksitsayi" hide-details="" v-model="Movement.InstallmentID" 
                            item-text="TaksitAciklama" item-value="TaksitID" clearable :label="$t('Instalment')">
                            </v-select>
                        </v-flex>
                      </v-layout>
                      <v-autocomplete :items="masrafmerkezi" hide-details="" :label="$t('Expense-Center-v2')" item-text="Title"
                        clearable v-model="Movement.ExpenseCenter" item-value="Code"></v-autocomplete>
                      <!-- <v-autocomplete hide-details="" :items="Referans" :label="$t('Reference')" v-model="Movement.Reference"
                        clearable item-text="Title" item-value="Kod"></v-autocomplete> -->
                        <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="Movement.Reference" >
                              </referansmerkezicomp>
                      <v-select hide-details="" :items="makbuztipi" @select="evraktipkontrol()" :label="$t('Receipt-Type')"
                        clearable item-text="text" v-model="Movement.ReceiptType" item-value="value"></v-select>

                <v-checkbox v-if="PB=='TRY'" hide-details v-model="Movement.AccountingIntegration" :label="$t('Integrate-into-Accounting')"></v-checkbox>


                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex pa-1 xs12 sm12 md4>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-card class="white--text">
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>
                          <v-autocomplete :items="doviztipi" item-text="Title" @change="kurgetir(Movement.ExchangeType)"
                            item-value="DovizKod" hide-details="" v-model="Movement.ExchangeType" :label="$t('Currency-Type')"
                            clearable></v-autocomplete>
                          <dovizinput v-model="Movement.ExchangeRate" :etiket="$t('Foreign-Currency-Exchange-Rate-Amount')"
                            :autocomplete="autocomplete"></dovizinput>
                          <doviztutarcomp :name="doviztutar" v-model="Movement.ExchangeAmount" @input="dovizTutarHesap()"
                            :etiket="etiketdoviztutar" :id="doviztutar" :autocomplete="autocomplete"></doviztutarcomp>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pt-2 xs12 sm12 md12 v-if="PB=='TRY' && kdvGoster==true">
                  <v-card class="white--text">
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>

                          <parainput v-model="Movement.GrossAmount" :simge="getparabirimi()" :etiket="$t('Gross')" :autocomplete="autocomplete">
                          </parainput>
                          <parainput v-model="Movement.DiscountAmount" :simge="getparabirimi()" :etiket="$t('Discount')" :autocomplete="autocomplete">
                          </parainput>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <yuzdeinput :etiket="$t('Tax-v2') + ' %'" v-model="Movement.TaxRate" :autocomplete="'autocomplete'">
                              </yuzdeinput>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <parainput v-model="Movement.TaxAmount" :simge="getparabirimi()" :etiket="$t('VAT-Amount')"
                                :autocomplete="autocomplete"> </parainput>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
                <v-btn v-if="PB=='TRY'" color="info" @click="karsicariac()" small block>  {{ $t('Enter-Counteraction') }} </v-btn>
              </v-layout>
            </v-flex>

            <v-layout v-if="karsicari" row="" wrap="">
              <v-flex xs12 sm12 md12>
                <div v-if="karsicari">
                  <v-card flat="" color="#9E9E9E">
                    <v-card-title>
                      <span class="subheading white--text font-weight-medium ">  {{ $t('Counteraction-Details') }} </span>
                    </v-card-title>
                  </v-card>
                </div>
              </v-flex>

              <v-flex pa-1 xs12 sm12 md4>
                <v-card class="white--text">
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout justify-space-between column>

                       <cariaracomp v-bind:etiket="$t('Select-Counter-Current')" v-bind:value="Movement.ContraCurrent" :loading="loading" 
                             v-model="Movement.ContraCurrent" ></cariaracomp>

                        <v-autocomplete :items="EvrakTipi2" clearable hide-details=""
                          v-model="Movement.ContraDocumentType" v-bind="EvrakTipi2" item-text="Title"
                          item-value="Evrakkod" :label="$t('Counter-Document-Type')"></v-autocomplete>


             

                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>

              </v-flex>


              <v-flex pa-1 xs12 sm12 md4>
                <v-card class="white--text">
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout justify-space-between column>
                        <v-textarea :label="$t('Counter-Explanation')" v-model="Movement.ContraExplanation" value=""></v-textarea>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
              <v-flex pa-1 xs12 sm12 md4>
                <v-card class="white--text">
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout justify-space-between column>
                        <v-autocomplete hide-details="" @change="kurgetir1(Movement.ContraExchangeType)"
                          :items="doviztipi" item-text="Title" item-value="DovizKod" clearable :label="$t('Counter-Currency-Type')"
                          v-model="Movement.ContraExchangeType"></v-autocomplete>

                        <dovizinput v-model="Movement.ContraExchangeRate" :etiket="$t('Foreign-Currency-Exchange-Rate-Amount')"
                          :autocomplete="autocomplete"></dovizinput>

                        <doviztutarcomp :name="karsidoviztutar" v-model="Movement.ContraExchangeAmount" 
                          :etiket="karsietiktutar" :id="karsidoviztutar" :autocomplete="autocomplete"></doviztutarcomp>

                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

            </v-layout>

          </v-layout>


          <v-layout v-show="faturakapatmaview" row wrap>
            <v-flex xs12 pa-2 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>

                          <v-flex xs12 sm8 md8>
                            <v-layout row wrap>

                              <v-flex xs12 pa-2 sm12 md12>
                                <v-layout align-start="" justify-start="" fill-height="">
                                  <span class="subheading grey--text font-weight-bold">
                                    <v-icon large>account_box</v-icon> {{Title.Kod}} - {{Title.Unvan}}
                                  </span>
                                </v-layout>
                                <v-divider></v-divider>
                              </v-flex>

                              <v-flex xs12 pr-2 pl-2 sm12 md12>
                                <v-layout align-start="" justify-start="" fill-height="">
                                  <span class="subheading grey--text font-weight-bold">
                                    <v-icon large>receipt</v-icon> {{Title.EvrakTip}} - {{Title.EvrakKod}}
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm12 pl-2 md12>
                                <v-layout align-center="" row wrap>
                                  <v-flex xs12 sm3 md3>
                                    <tarihcomp :etiket="$t('Date')" :detaygizle="true" v-model="kapatma.Tarih"
                                      v-bind:defaultvalue="'ok'"></tarihcomp>
                                  </v-flex>
                                  <v-flex xs12 sm4 md2>
                                    <v-layout align-center="" justify-start="" row wrap>
                                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false"
                                        ref="fab" @click="filtrele()" color="info" fab dark>
                                        <v-icon>filter_list</v-icon>
                                      </v-btn>
                                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                        <span>{{$t('Add-Search-Filter')}}</span>
                                      </v-tooltip>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex xs12 pa-2 sm7 md7>
                                    <v-layout justify-end>
                                      <v-flex xs12 pa-2 sm4 md4>
                                        <v-btn @click="otomatikAta()" block color="info"> {{ $t('Automatic-Search') }}
                                        </v-btn>
                                      </v-flex>
                                      <v-flex xs12 pa-2 sm4 md4>
                                        <v-btn @click="KapatmaKaydet()" block="" color="info">{{$t("save_button")}} </v-btn>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 pa-2 sm2 md2>
                            <v-card flat color="#1E88E5" class="white--text">
                              <v-layout>
                                <v-flex xs3 sm3 pa-1 md3>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="white" large="">add</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm9 md9>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout>
                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">

                                              <span class="headline font-weight-thin">
                                                {{kapatma.Odeme | moneyformat}}{{getparabirimi()}}
                                              </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-card-actions class="pa-3">
                                <v-layout justify-end="">
                                  <span class="subheading font-weight-"> {{ $t('Collection-Amount') }} </span>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-flex>

                          <v-flex xs12 pa-2 sm2 md2>
                            <v-card flat color="#FF5252" class="white--text">
                              <v-layout>
                                <v-flex xs3 sm3 pa-1 md3>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <v-icon color="white" large="">remove</v-icon>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm9 md9>
                                  <v-card-title primary-title="">
                                    <v-flex xs12 sm12 md12>
                                      <v-layout>
                                        <v-flex xs12 pa-2 sm12 md12>
                                          <v-list-tile-title>
                                            <v-layout justify-end="">

                                              <span class="headline font-weight-thin">
                                                {{kapatma.Kalan | moneyformat}}{{getparabirimi()}}
                                              </span>
                                            </v-layout>
                                          </v-list-tile-title>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>
                                  </v-card-title>
                                </v-flex>
                              </v-layout>
                              <v-divider light></v-divider>
                              <v-card-actions class="pa-3">
                                <v-layout justify-end="">

                                  <span class="subheading font-weight-"> {{ $t('Remaining-Amount') }} </span>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-flex>



                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 pa-2 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat>
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 pa-2 sm12 md12>
                        <v-layout align-start="" justify-start="" fill-height="">
                          <span class="headline grey--text font-weight-regular">
                            {{ $t('Invoice-Details') }}
                          </span>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-flex>


                      <v-flex xs12 pa-2 sm12>
                        <v-data-table :headers="headerskapatma" :loading="progress" :rows-per-page-items=[50,100]
                          :items="itemskapatma" :search="searchkapatma">
                          <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                          <template slot="items" slot-scope="props">
                            <tr @click="detaygetir(props.item)" item>
                              <v-switch v-model="check[props.item.RecNo]" @change="EkleKaldir(props.item,$event)">
                              </v-switch>
                              <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                              <td class="text-xs-left">{{ props.item.Faturano}}</td>
                              <td class="text-xs-left">{{ props.item.OnayFaturaNo }}</td>
                              <td class="text-xs-left">{{ props.item.Tip }}</td>
                              <td class="text-xs-left">{{ props.item.FaturaTarih | dateformat}}</td>
                              <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>
                              <td class="text-xs-right">{{ props.item.Odeme  | moneyformat}}</td>

                              <td class="text-xs-left">{{ props.item.CoperID }}</td>
                              <td class="text-xs-left">{{ props.item.CSirket }}</td>
                            </tr>
                          </template>
                          <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            {{ $t('No-records-searched-for', { value: searchkapatma}) }}
                          </v-alert>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex xs12 pa-2 sm5 md5>
              <v-card flat class="white--text">
                <v-card flat>
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 pa-2sm12 md12>
                        <v-layout align-start="" justify-start="" fill-height="">
                          <span class="headline grey--text font-weight-regular">
                            {{ $t('Invoice-Information') }}
                          </span>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-flex>

                      <v-flex xs12 sm12>

                        <v-data-table :headers="headerskapatmadetay" no-action :items="itemskapatmadetay"
                          :search="searchkapatmadetay">
                          <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                          <template slot="items" slot-scope="props">
                            <tr @click="git(props.item)" item>
                              <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                              <td class="text-xs-left">{{ props.item.Faturano }}</td>
                              <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                              <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>

                            </tr>
                          </template>
                          <v-alert slot="no-results" :value="true" color="error" icon="warning">
                             {{ $t('No-records-searched-for', { value: searchkapatma}) }}
                          </v-alert>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex xs12 pa-2 sm7 md7>
              <v-card flat class="white--text">
                <v-card flat>
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 pa-2 sm12 md12>
                        <v-layout align-start="" justify-start="" fill-height="">
                          <span class="headline grey--text font-weight-regular">
                            {{ $t('Collection-Details-Approval') }}
                          </span>
                        </v-layout>
                        <v-divider></v-divider>
                      </v-flex>

                      <v-flex xs12 sm12>

                        <v-data-table :headers="headerskapatmaodeme" no-action :items="itemskapatmaodeme"
                          :search="searchkapatma">
                          <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                          <template slot="items" slot-scope="props">
                            <tr item>

                              <td class="text-xs-left">{{ props.item.FaturaSeri }}</td>
                              <td class="text-xs-left">{{ props.item.FaturaNo}}</td>
                              <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                              <td class="text-xs-left">{{ props.item.Tip }}</td>
                              <td class="text-xs-left">{{ props.item.Tutar | moneyformat}}</td>
                              <td class="text-xs-left">{{ props.item.FaturaID }}</td>
                              <td class="text-xs-left">{{ props.item.BiletID }}</td>
                              <td class="text-xs-right">{{ props.item.BiletHYID  }}</td>
                              <td class="text-xs-right">{{ props.item.OdemeKod }}</td>
                              <td class="text-xs-right">{{ props.item.SiraNo}}</td>
                              <td class="text-xs-left">{{ props.item.CKart }}</td>
                              <td class="text-xs-left">{{ props.item.CoperID }}</td>
                              <td class="text-xs-left">{{ props.item.CoperSirket }}</td>
                              <td class="text-xs-left">{{ props.item.RecordNo }}</td>

                            </tr>
                          </template>
                          <v-alert slot="no-results" :value="true" color="error" icon="warning">
                              {{ $t('No-records-searched-for', { value: searchkapatma}) }}
                          </v-alert>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>



            <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="450px">
              <v-card>
                <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>

                  <v-flex pa-1 xs12 sm12 md12>
                    <v-card flat>
                      <v-card flat="">
                        <v-card-actions>
                          <v-layout row="" wrap="">
                            <v-flex xs12 sm6 md6>
                              <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="true"
                                v-model="FaturaKapatma.Filtreler.Tarih1"></tarihcomp>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="true"
                                v-model="FaturaKapatma.Filtreler.Tarih2">
                              </tarihcomp>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field mask="############" hide-details=""
                                v-model="FaturaKapatma.Filtreler.BaslangicFatNo" :label="$t('Invoice-No')"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-text-field mask="############" v-model="FaturaKapatma.Filtreler.BitisFatNo"
                                hide-details="" :label="$t('Invoice-No')"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <parainput :simge="getparabirimi()" v-model="FaturaKapatma.Filtreler.TutarMin" :etiket="$t('Remaining')"
                                :autocomplete="autocomplete">
                              </parainput>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <parainput :simge="getparabirimi()" v-model="FaturaKapatma.Filtreler.TutarMax" :etiket="$t('Remaining')"
                                :autocomplete="autocomplete">
                              </parainput>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                  <v-flex xs12 pl-1 pr-1 pt-2 sm12 md12>
                    <v-layout align-start="" justify-start="" fill-height="">
                      <span class="subheading grey--text font-weight-">
                        {{ $t('Options-v2') }}
                      </span>
                    </v-layout>
                    <v-divider></v-divider>
                  </v-flex>

                  <v-layout row pa-1 wrap>

                    <v-flex xs12 sm6 md6>
                      <v-radio-group v-model="FaturaKapatma.Filtreler.Fatsec" :label="$t('Invoice-Type-v2')">
                        <v-radio :label="$t('All')" value="H"></v-radio>
                        <v-radio :label="$t('Ticket')" value="B"></v-radio>
                        <v-radio :label="$t('Free')" value="S"></v-radio>
                        <v-radio label="Coper" value="C"></v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <v-radio-group v-model="FaturaKapatma.Filtreler.TarihTip" label="Tarih Tip">
                        <v-radio :label="$t('Invoice-Date')" value="T"></v-radio>
                        <v-radio :label="$t('Maturity-Date')" value="V"></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click="kapatmafiltreiptal()">{{ $t('cancel_button') }}</v-btn>
                  <v-btn color="blue darken-1" flat @click.native="filtrekayit()"> {{ $t('Apply-Filters') }} </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>

          <v-layout row justify-center>
            <v-dialog v-model="dialogCheck" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">{{$t('Warning')}}</v-card-title>
                <v-card-text>{{dialogMessage}} <br /> {{dialogMessage2}} </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click.native="dialogCheck = false, butongorunum = true">{{$t('cancel_button')}}</v-btn>
                  <v-btn color="primary" flat @click="currentDateCheck()">{{$t('Continue')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>


        </v-layout>
      </v-card>
    </v-form>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import parainput from '../customcomp/parainput'
  import dovizinput from '@/components/app/customcomp/dovizinput.vue'
  import doviztutarcomp from '@/components/app/customcomp/doviztutarcomp.vue'
  import kredikartcomp from "@/components/app/bilet/partpage/kredikartcomp.vue"
  import yuzdeinput from '../customcomp/yuzdeinput'
  import caricomp from '@/components/app/customcomp/caricomp.vue'
  import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp.vue'
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import loadingcomp from "@/components/app/customcomp/loadingcomp"
  import cariaracomp from '@/components/app/customcomp/cariaracomp'
  import bankakodu from '@/components/app/customcomp/bankakodu'
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import tool from "@/components/app/coper/tools";

  export default {

    props: {
      operation: ''
    },

    data() {
      return {
        kdvGoster:true,
        PB:"TRY",
        saveCounter:0,
        dialogMessage:'',
        dialogMessage2:'',
        dialogCheck:false,
        butongorunum: true,
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        iptalno: null,
        check: [],
        caricompitems: [],
        islemdurum: true,
        ekbaslik: null,
        brutgirilentoplam: 0,
        tutardisabled: true,
        tooltip: false,
        el: null,
        dialogfiltre: false,
        kapatma: {
          Tarih: null,
          Odeme: 0,
          Kalan: 0,
          OdemeKod: null,
        },
        Title: {
          Kod: null,
          Unvan: null,
          EvrakTip: null,
          EvrakKod: null,
        },
        headerskapatma: [{
            text: this.$t('Approval'),
            value: 'Onay',
            sortable: false
          },
          {
            text: this.$t('Invoice-Serial'),
            value: 'FaturaSeri',
            sortable: false
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano',
            sortable: false

          },
          {
            text: 'Onay Fat. No',
            value: 'OnayFaturaNo',
            sortable: false
          },
          {
            text: this.$t('Type'),
            value: 'Tip',
            sortable: false
          },
          {
            text: this.$t('Invoice-Date'),
            value: 'FaturaTarih',
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
            sortable: false
          },
          {
            text: this.$t('Payment'),
            value: 'Odeme',
            sortable: false
          },
          {
            text: 'Coper ID',
            value: 'CoperID',
            sortable: false
          },
          {
            text: 'Cs Şirket',
            value: 'CSirket',
            sortable: false
          }
        ],
        itemskapatma: [],
        searchkapatma: null,
        headerskapatmadetay: [{
            text: this.$t('Invoice-Serial'),
            value: 'FaturaSeri'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano',
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',

          },
          {
            text: this.$t('Amount'),
            value: 'Tutar'
          }
        ],
        headerskapatmaodeme: [{
            text: this.$t('Invoice-Serial'),
            value: 'FaturaSeri'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'Faturano',
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama',
          },
          {
            text: this.$t('Type'),
            value: 'Tip'
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar'
          },
          {
            text: 'Fat. ID',
            value: 'FaturaID'
          },
          {
            text: this.$t('Ticket-ID'),
            value: 'BiletID'
          },
          {
            text: this.$t('Ticket-AL-ID'),
            value: 'BiletHYID'
          },
          {
            text: this.$t('Payment-Code'),
            value: 'OdemeKod'
          }, {
            text: this.$t('Issue'),
            value: 'SiraNo'
          },
          {
            text: 'Coper ID',
            value: 'CoperID'
          },
          {
            text: this.$t('Coper-Corporation'),
            value: 'CoperSirket'
          },
          {
            text: this.$t('Record-No'),
            value: 'RecordNo'
          }
        ],
        itemskapatmaodeme: [],
        itemskapatmadetay: [],
        searchkapatmadetay: null,
        carihareketview: true,
        faturakapatmaview: false,
        carideneme: null,
        FaturaKapatma: {
          Tip: 0,
          FiltreInfo: false, // false : filtre yok, true : filtre var
          Filtreler: {
            HesapKodu: null,
            FatGoster: null, // H - sorgulama yok , S - Sorgulama var
            Tarih1: null,
            Tarih2: null,
            Tarih3: null,
            BaslangicFatNo: null,
            BitisFatNo: null,
            Fatsec: null, //H - hepsi, B - Bilet, S- Serbest, C- Coper
            TutarMin: 0,
            TutarMax: 0,
            TarihTip: 'T', // V - Vade tarihi, F- Fatura Tarihi
            BiletDb: null,
            SirketKod: null,
          },
          CariInfo: {
            SirketKodu: null,
            Tarih: null,
            CariKodu: null,
            Sirano: null,
            QueryBool: false,
            QueryCmd: false,
          }
        },
        loadingvmodel: null,
        tutarevent: false,
        digerevent: false,
        drawer: null,
        baslik: '',
        e1: 0,
        Code: '',
        e2: true,
        rules: {
          required: (value) => !!value || this.$t('Mandatory-Areas'),
          email: (value) => {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || this.$t('Wrong-e-mail')
          }
        },
        progress: false,
        valid: true,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: ' #',
          precision: 2,
          masked: false /* doesn't work with directive */
        },
        loading: false,
        loadingkarsi: false,
        search: '',
        search1: '',
        searchkarsi: '',
        karsicari: true,
        statecari: [],
        statecari2: [],
        statekarsi: [],
        masrafmerkezi: [],
        Referans: [],
        states1: [{
          text: this.$t('Credit'),
          value: 'A'
        }, {
          text: this.$t('Debit'),
          value: 'B'
        }],
        doviztipi: [],

        EvrakTipi1: [],
        EvrakTipi2: [],
        items1: [],

        Movement: {
          Current: '',
          TaxRate: 0,
          ContraCurrent: 0,
          MovementDate: null,
          MovementDueDate: null,
          DocumentType: '',
          DocumentNumber: '',
          Explanation: '',
          DebitCredit: '',
          Amount: 0,
          ExchangeType: '',
          ExchangeRate: 0,
          ExchangeAmount: 0,
          ContraDocumentType: '',
          ContraDocumentNumber: '',
          ContraExplanation: '',
          ContraExchangeType: '',
          ContraExchangeRate: 0,
          ContraExchangeAmount: 0,
          PaymentCode: '',
          Reference: '',
          ExpenseCenter: null,
          CompanyCode: '',
          ReceiptType: '',
          FirmCardNumber: null,
          PosCode: null,
          InstallmentID: null,
          InstallmentExplanation: null,
          GrossAmount: 0,
          TaxAmount: 0,
          DiscountAmount: 0,
          ContraAccount: null,
          BankCode:null,
          AccountingIntegration:true
        },

        taksitsayi: [],

        makbuztipi: [{
            text: this.$t('Other'),
            value: '0'
          },
          {
            text: this.$t('Collection-v2'),
            value: '1'
          },
          {
            text: this.$t('Payment-v2'),
            value: '2'
          }
        ],
        dictionary: {
          custom: {
            carikod: {
              required: () => this.$t('Please-choose'),
            },
            tarih: {
              required: () => this.$t('This-space-cannot-left-blank'),
            },
            ba: {
              required: () => this.$t('Please-choose'),
            },
            tutar: {
              required: () => this.$t('Please-enter-amount-v2'),
              min_value: () => this.$t('The-amount-must-greater-than')
            },

          }
        },
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        autocomplete: 'autocomplete',
        tutar: 'tutar',
        etikettutar: this.$t('Amount'),
        doviztutar: 'doviztutar',
        etiketdoviztutar: this.$t('Currency-Amount'),
        kurtutar: 'kurtutar',
        etiketkurtutar: this.$t('Exchange-Rate'),
        karsikurtutar: 'karsikurtutar',
        karsietiketkurtutar: this.$t('Counter-Exchange-Rate'),
        karsidoviztutar: 'karsidoviztutar',
        karsietiktutar: this.$t('Counter-Exchange-Amount'),
        bankapositems: null,

      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    created() {},
    beforeDestroy() {
    },
    methods: {
      checkData(){ 
        this.butongorunum = false;
        
        var today = new Date();
        let year = today.getFullYear();
        
        
        let mainDate = new Date(this.Movement.MovementDate);
        let mainYear = mainDate.getFullYear();

        let mainCheckResult = year - mainYear;
        let dueCheckResult = this.gunfarki(today,this.Movement.MovementDueDate);  
        
        if(mainCheckResult != 0){
        this.dialogCheck = true;
        this.dialogMessage += " Kayıt Tarihi Sene içinde değildir.";
        }else if(dueCheckResult > 30){
          this.dialogMessage2 += " Vade Tarihi 1 aydan ileridedir.";
          this.dialogCheck = true;
        }
        else{
          this.Kaydet();
        }

    

      },
      gunfarki(a, b) {
      var dt1 = new Date(a);
      var dt2 = new Date(b);

      return Math.floor(
        (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
          Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
          (1000 * 60 * 60 * 24)
      );
      },
      currentDateCheck(){
        if(this.dialogCheck){
          this.Kaydet();
          this.dialogCheck = false;
        }else{
         this.butongorunum = true;
        }
      },
      getCurrentInfo(currentInfo){
        this.Movement.ExpenseCenter = currentInfo.ExpenseCenter; 
      },
      dovizTutarHesap(){
      this.Movement.Amount = this.Movement.ExchangeRate * this.Movement.ExchangeAmount
      },
      tutarHesapla(){
      if (this.Movement.Amount != 0 && this.Movement.ExchangeRate != 0) {
          this.Movement.ExchangeAmount = this.Movement.Amount / this.Movement.ExchangeRate;
        }

        this.brutHesapla(this.Movement.Amount, this.Movement.TaxRate)
      },
      test(){

         var toplam = helpers.roundNumber(this.Movement.GrossAmount - this.Movement.DiscountAmount + this.Movement.TaxAmount,2)
           if (helpers.roundNumber(this.Movement.Amount,2) >= toplam) {
           }

      },
      getparabirimi(){
           return helpers.getparabirimi()
      },
      otomatikAta() {
        var prmkapama = {
          FaturaInfo: this.itemskapatma,
          SeciliOdemeList: {
            OdemeTarihi: this.kapatma.Tarih,
            OdemeKod: this.kapatma.OdemeKod,
            OdemeTutar: this.kapatma.Odeme,
            KalanTutar: this.kapatma.Kalan,
            OdemeList: this.itemskapatmaodeme
          }
        }

        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchAutomaticList', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.kapatma.Kalan = response.body.KalanTutar
          this.itemskapatmaodeme = response.body.OdemeList



          this.islemdurum = false

          this.itemskapatmaodeme.forEach(element1 => {
            this.itemskapatma.forEach(element2 => {
              if (element1.RecordNo == element2.RecNo) {

                this.check[element2.RecNo] = true
              }
            });
          });

          this.islemdurum = true


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }

        })
      },
      EkleKaldir(a, b) {

     
        if (this.islemdurum == true) {

          if (this.kapatma.Kalan > 0 || b == false) {

            var eklekaldir

            if (b == true) {
              eklekaldir = false
            } else {
              eklekaldir = true
            }

            var prmkapama = {
              EkleKaldir: eklekaldir,
              FaturaInfo: a,
              SeciliOdemeList: {
                OdemeTarihi: this.kapatma.Tarih,
                OdemeKod: this.kapatma.OdemeKod,
                OdemeTutar: this.kapatma.Odeme,
                KalanTutar: this.kapatma.Kalan,
                OdemeList: this.itemskapatmaodeme
              }
            }
            this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchPaymentAddRemoveList', prmkapama, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              if (response.body.ResponseInfo.Status == true) {
                this.kapatma.Kalan = response.body.KalanTutar
                this.itemskapatmaodeme = response.body.OdemeList
              } else {
                this.text1 = this.$t('Add-Remove-process-could-not-completed')
                this.snackbar = true
              }
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              }
            })

          } else {
            this.text1 = this.$t('cannot-add-since-remaining-amount')
            this.snackbar = true

            this.check[a.RecNo] = false
          }

        }

      },
      KapatmaKaydet() {


        var prmkapama = {
          OdemeTarihi: this.kapatma.Tarih,
          OdemeKod: this.kapatma.OdemeKod,
          OdemeTutar: this.kapatma.Odeme,
          KalanTutar: this.kapatma.Kalan,
          OdemeList: this.itemskapatmaodeme
        }

        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchPaymentSave', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.butongorunum = true

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status == true) {

            this.ekbaslik = ''
            this.carihareketview = true
            this.faturakapatmaview = false
            this.ekbaslik = null
            this.itemskapatmaodeme = []
            this.itemskapatmadetay = []
            this.check = []
            this.itemskapatma = []
            this.clearClass();
          } else {

          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
      },
      git() {},
      filtrele() {
        this.dialogfiltre = true
        this.FaturaKapatma.Filtreler.Fatsec = 'H'
      },
      kapatmafiltreiptal() {

        this.dialogfiltre = false
        this.FaturaKapatma.Filtreler.FatGoster = null // H - sorgulama yok , S - Sorgulama var
        this.FaturaKapatma.Filtreler.Tarih1 = ''
        this.FaturaKapatma.Filtreler.Tarih2 = ''
        this.FaturaKapatma.FiltreInfo = false
        this.FaturaKapatma.Filtreler.BaslangicFatNo = null
        this.FaturaKapatma.Filtreler.BitisFatNo = null
        this.FaturaKapatma.Filtreler.Fatsec = null //H - hepsi, B - Bilet, S- Serbest, C- Coper
        this.FaturaKapatma.Filtreler.TutarMin = 0
        this.FaturaKapatma.Filtreler.TutarMax = 0
        this.FaturaKapatma.Filtreler.TarihTip = 'T' // V - Vade tarihi, F- Fatura Tarihi
        this.FaturaKapatma.Filtreler.BiletDb = null
        this.FaturaKapatma.Filtreler.SirketKod = null
        this.FaturaKapatma.FiltreInfo = false

        var prmkapama = this.FaturaKapatma

        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchInvoiceList', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.FaturaInfo.length > 0) {
            this.itemskapatma = response.body.FaturaInfo
            this.dialogfiltre = false

          } else {
            this.text1 =this.$t('No-Records-Found')
            this.snackbar = true
            this.dialogfiltre = false
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }

        })



      },
      filtrekayit() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.FaturaKapatma.Filtreler.FatGoster = 'S'
        this.FaturaKapatma.Filtreler.SirketKod = credentials.SirketKodu
        this.FaturaKapatma.FiltreInfo = true

        var prmkapama = this.FaturaKapatma

        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchInvoiceList', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.FaturaInfo.length > 0) {
            this.itemskapatma = response.body.FaturaInfo
            this.dialogfiltre = false

          } else {
            this.text1 =this.$t('No-Records-Found')
            this.snackbar = true
            this.dialogfiltre = false
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }

        })

      },
      detaygetir(value) {

        var prmkapama = {
          FaturaID: value.FaturaID,
          BiletID: value.BiletID,
          BiletHYID: value.BiletHYID,
          Tip: value.Tip
        }
        this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchInvoiceDetailList', prmkapama, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.itemskapatmadetay = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }

        })
      },
      brutHesapladiscount(tutar, kdv) {
        var kdvsiztutar = tutar / (kdv / 100 + 1)
        this.Movement.TaxAmount = (kdvsiztutar / 100) * kdv
        this.Movement.GrossAmount = tutar - this.Movement.TaxAmount
      },
      brutHesapla(tutar, kdv) {
        var kdvsiztutar = tutar / (kdv / 100 + 1)
        this.Movement.TaxAmount = (kdvsiztutar / 100) * kdv
        this.Movement.GrossAmount = tutar - this.Movement.TaxAmount
        if (this.Movement.DiscountAmount != 0) {
          this.Movement.GrossAmount = this.Movement.GrossAmount + this.Movement.DiscountAmount
        }
      },
      taksitgetir(v) {
        var tumliste = []
        tumliste = this.bankapositems
        tumliste.forEach(element => {
          if (element.PosKodu == v) {
            this.taksitsayi = []
            this.taksitsayi = element.Taksitler   
     
          }
        });
      },
      clearClass() {
        this.Movement.CariHareketKey = null;
        this.Movement.MovementDate = getDateNow();
        this.Movement.MovementDueDate = getDateNow();
        this.Movement.Current = null
        this.Movement.ContraCurrent = 0
        this.Movement.DocumentType = null
        this.Movement.DocumentNumber = null
        this.Movement.Explanation = null
        this.Movement.DebitCredit = null
        this.Movement.Amount = 0
        this.Movement.ExchangeType = null
        this.Movement.ExchangeRate = 0
        this.Movement.ExchangeAmount = 0
        this.Movement.ContraDocumentType = null
        this.Movement.ContraDocumentNumber = null
        this.Movement.ContraExplanation = null
        this.Movement.ContraExchangeType = null
        this.Movement.ContraExchangeRate = 0
        this.Movement.ContraExchangeAmount = 0
        this.Movement.PaymentCode = null
        this.Movement.Reference = null
        this.Movement.ExpenseCenter = null
        this.Movement.ReceiptType = null
        this.Movement.ContraAccount = null
        this.Movement.GrossAmount = 0
        this.Movement.DiscountAmount = 0
        this.Movement.TaxAmount = 0
        this.Movement.FirmCardNumber = null
      },
      kurgetir(kod) {
        
        
        var params1 = {
          Tarih: this.Movement.MovementDate,
          DovizKod: kod
        }
        

        this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
          headers: auth.getAuthCompaniesInfo()
        }).then((response) => {
          if(response.body == 0.0){
             this.Movement.ExchangeRate = 1
          }else{
             this.Movement.ExchangeRate = response.body
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },
      kurgetir1(kod) {
        var params1 = {
          Tarih: this.Movement.MovementDate,
          DovizKod: kod
        }

        this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
          headers: auth.getAuthCompaniesInfo()
        }).then((response) => {
         if(response.body == 0.0){
             this.Movement.ContraExchangeRate = 1
          }else{
              this.Movement.ContraExchangeRate = response.body
          }
         
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Kur Hesapla'
            this.snackbar = true
          }
        })
      },
      karsicariac: karsicariac,
      Kaydet: Kaydet,
      evraktipkontrol: evraktipkontrol,
      makbuztipkontrol: makbuztipkontrol,
      getBankaHareketi:getBankaHareketi,
    },
    beforeMount: beforeMount,
    components: {
      'parainput': parainput,
      dovizinput,
      tarihcomp,
      doviztutarcomp,
      kredikartcomp,
      yuzdeinput,
      caricomp,
      yetkidialog,
      loadingcomp,
      muhasebekoducomp,
      cariaracomp,
      bankakodu,
      referansmerkezicomp
    },
    mounted() {
     
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
      
      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        this.Movement.ReceiptType = null
        this.Movement.Reference = null


        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
        var params = {
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.bankapositems = response.body
          this.progress = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-bankpos'
            this.progress = false
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-bankpos'
            this.snackbar = true
            this.progress = false
          }
        })

        this.$http.post(auth.API_URL + 'api/currency/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Döviz Tipi'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Döviz Tipi'
            this.snackbar = true
          }
        })


        this.$http.post(auth.API_URL + 'api/doctype/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.EvrakTipi1 = response.body
          this.EvrakTipi2 = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Evrak Tipi'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Evrak Tipi'
            this.snackbar = true
          }
        })

        this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.masrafmerkezi = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Masraf Merkezi'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Masraf Merkezi'
            this.snackbar = true
          }
        })

        // this.$http.post(auth.API_URL + 'api/Reference/List', params, {
        //   headers: {
        //     'Authorization': 'Bearer ' + auth.getAuthHeader()
        //   }
        // }).then((response) => {
        //   this.Referans = response.body
        // }, (response) => {
        //   if (response.status === 0) {
        //     this.text1 = 'Service Unavailable-Referans'
        //     this.snackbar = true
        //   } else {
        //     this.text1 = 'Service Unavailable-Referans'
        //     this.snackbar = true
        //   }
        // })


        this.$http.post(auth.API_URL + 'api/Parameters/Get', null, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.Movement.TaxRate = parseFloat(response.body.KdvOran)
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true

          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true

          }
        })

        this.karsicari = false

        if((this.$route.query.id != null) && (this.$route.query.id != "")){
          this.getBankaHareketi(this.$route.query.id);
          this.Movement.ContraDocumentType='HV'
        }
      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }

      if((this.$route.query.id != null) && (this.$route.query.id != "")){
         
      this.Movement.DocumentType='HV'
        }
    },
    watch: {
      'Movement.ExchangeRate': function (value) {
        if (value != 0) {
          this.Movement.ExchangeAmount = this.Movement.Amount / value;
        }
      },
      iptalno(value) {
        this.check[value] = false

      },

      'Movement.DocumentType': function (value) {

        this.Movement.ContraDocumentType = String(value)

        this.EvrakTipi1.forEach(element => {
          if (element.Evrakkod == value) {

            if (element.Cari == '-' || element.Cari == '+') {
              this.kdvGoster = true
            } else {
              this.kdvGoster = false
            }

            if (element.Cari != 'Yok') {
              this.tutardisabled = false
            } else {
              this.tutardisabled = true
            }

            if (element.BA.trim() == 'Alacak') {
              this.Movement.DebitCredit = 'A'
            } else if (element.BA.trim() == 'Borç') {
              this.Movement.DebitCredit = 'B'
            }

            if (this.Movement.Explanation == null || this.Movement.Explanation == '') {
              this.Movement.Explanation = element.Title
            } else {

            }
          }
        });

      },

      'Movement.ContraDocumentType': function (value) {

        this.EvrakTipi1.forEach(element => {

          if (element.Evrakkod == value) {

            if (this.Movement.ContraExplanation == null || this.Movement.ContraExplanation == '') {
              this.Movement.ContraExplanation = element.Title
            } else {

            }

          }
        });

      },

      'Movement.DiscountAmount': function (value) {

        this.brutHesapladiscount(this.Movement.Amount, this.Movement.TaxRate)

        if (this.Movement.Amount != 0) {
          this.Movement.GrossAmount = this.Movement.GrossAmount + value
        } else {
          this.Movement.GrossAmount = value
        }

      },

      'Movement.TaxRate': function (value) {
        this.brutHesapla(this.Movement.Amount, value)
      },

      'Movement.TaxAmount': function (value) {

      },

    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },


  }

  
  function getBankaHareketi(val) {


      var params = {
        Filtreler: {
         id:val,
        },
        Sayfa: 1,
        Top : 10,
       
        tumSirketler: false,
        sayfaAdi: "",
      };

      tool.api_post(this, "BankaStream/HesapHareketleri", params).then(
        (response) => {
          if (response.body.Status == true) {
              let BankaHareketi = response.body.data[0];
              //console.log(BankaHareketi);

              this.Movement.CariHareketKey = BankaHareketi.id;

              if(BankaHareketi.currency=="TRY")
              {
                this.Movement.ExchangeType="TL";
              }else{
                this.Movement.ExchangeType=BankaHareketi.currency;
              }
              
              
              this.Movement.Current = BankaHareketi.tenantArkmanCariKod;
              this.Movement.ExchangeRate=BankaHareketi.currencyValue;
              this.Movement.Amount=BankaHareketi.amount;
              this.Movement.MovementDate=BankaHareketi.transactionDateValue;
              this.Movement.MovementDueDate=BankaHareketi.transactionDateValue;
              //this.Movement.DocumentNumber
           
              
              if(BankaHareketi.debtOrCredit=="B")
              {
                this.Movement.DebitCredit="A";
              }
              else
              {
                this.Movement.DebitCredit="B";
              }

              this.Movement.Explanation=BankaHareketi.description;

              this.tutarHesapla();

              this.karsicariac();

              this.Movement.ContraCurrent = BankaHareketi.arkmanCariKod;

              this.Movement.ContraExchangeAmount = BankaHareketi.amount;
              this.Movement.ContraExchangeRate = BankaHareketi.currencyValue;
              this.Movement.ContraExchangeType = this.Movement.ExchangeType; 



          } else {
            
          }
        },
        (response) => {
         
        }
      );
  }

  function makbuztipkontrol() {
    if (this.Movement.ReceiptType != '0' && this.Movement.ReceiptType != null && this.Movement.ReceiptType != '') {
      this.Movement.DocumentNumber = null
      this.text1 = this.$t('cannot-enter-document-since-receipt-selected')
      this.snackbar = true
    }
  }


  function evraktipkontrol() {
    if (this.Movement.ReceiptType != '0') {
      this.Movement.DocumentNumber = null
    }
  }

  function Kaydet() {
 
    

    this.butongorunum = false

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.$refs.formbiletrapor.validate()) {
      this.loadingvmodel = true
      var currentMovement = this.Movement
      currentMovement['CompanyCode'] = credentials.SirketKodu
      if (this.Movement.Amount > 0) {
        var toplam =  helpers.roundNumber(this.Movement.GrossAmount - this.Movement.DiscountAmount + this.Movement.TaxAmount,2)
        console.log(helpers.roundNumber(this.Movement.GrossAmount,2))
        console.log(helpers.roundNumber(this.Movement.DiscountAmount,2))
        console.log(helpers.roundNumber(this.Movement.TaxAmount,2))
      console.log( helpers.roundNumber(this.Movement.Amount,2)) 
        if (helpers.roundNumber(this.Movement.Amount,2) >= toplam) {
            
            if(currentMovement.ExchangeType == null || currentMovement.ExchangeType == ''){
              if(credentials.ParaBirimi == 'TRY' || credentials.ParaBirimi == null || credentials.ParaBirimi == ''){
                  currentMovement.ExchangeType =  'TL';
                  currentMovement.ExchangeRate = 1;
                  currentMovement.ExchangeAmount = this.Movement.Amount * 1;
              }else{
                  currentMovement.ExchangeType =  credentials.ParaBirimi;
                  currentMovement.ExchangeRate = 1;
                  currentMovement.ExchangeAmount = this.Movement.Amount * 1;
              }
            }
            
          this.$http.post(auth.API_URL + 'api/CurrentMovement/New', currentMovement, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.loadingvmodel = false
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
            if (response.body.Status == true) {
              this.FaturaKapatma.CariInfo.Tarih = this.Movement.MovementDate
              this.FaturaKapatma.CariInfo.SirketKodu = credentials.SirketKodu
              this.FaturaKapatma.CariInfo.CariKodu = this.Movement.Current
              this.FaturaKapatma.CariInfo.Sirano = response.body.CariResponse.Sirano
              var prmkapama = this.FaturaKapatma
              this.$http.post(auth.API_URL + 'api/InvoiceMatch/InvoiceMatchInvoiceList', prmkapama, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {
                this.loadingvmodel = false
                if (response.body.ResponseInfo) {
                  this.ekbaslik = '(Fatura Kapatma)'
                  this.itemskapatma = response.body.FaturaInfo
                  this.kapatma.Tarih = this.Movement.MovementDate
                  this.kapatma.Odeme = this.Movement.Amount
                  this.kapatma.Kalan = this.Movement.Amount
                  this.kapatma.OdemeKod = response.body.CariHareketInfo.OdemeKod
                  this.Title.Kod = response.body.CariHareketInfo.Cari.Kod
                  this.Title.Unvan = response.body.CariHareketInfo.Cari.Unvan
                  this.Title.EvrakTip = response.body.CariHareketInfo.Evrak.Evrakkod
                  this.Title.EvrakKod = response.body.CariHareketInfo.Evrakno
                  this.carihareketview = false
                  this.faturakapatmaview = true
                } else {
                  this.ekbaslik = ''
                  this.butongorunum = true
                  this.carihareketview = true
                  this.faturakapatmaview = false
                  this.ekbaslik = null
                  this.clearClass();
                }
              }, (response) => {
                this.loadingvmodel = false

                if (response.status === 0) {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                } else {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                }

              })
           } else {

           }

          }, (response) => {
            this.butongorunum = true
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.loadingvmodel = false
            } else {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
              this.loadingvmodel = false
            }
          })

        } else {
          this.loadingvmodel = false
          this.butongorunum = true
          this.text1 = this.$t('The-total-of-Gross-+Discount-+VAT-cannot-be-more-than-the-Amount.')
          this.snackbar = true
        }

      } else {
        this.butongorunum = true
        this.text1 = this.$t('Please-enter-amount')
        this.snackbar = true
        this.loadingvmodel = false

      }
    } else {
      this.butongorunum = true

    }

  }


  function karsicariac() {
    if (this.karsicari === false) {

      this.karsicari = true
      this.Movement.ContraExplanation = this.Movement.Explanation
      this.Movement.ContraDocumentType = this.Movement.DocumentType

    } else {
      this.karsicari = false

    }
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function beforeMount() {
    
    this.Movement.ReceiptType = null
    this.Movement.Reference = null


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.bankapositems = response.body
      this.progress = false
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-bankpos'
        this.progress = false
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-bankpos'
        this.snackbar = true
        this.progress = false
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz Tipi'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/doctype/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.EvrakTipi1 = response.body
      this.EvrakTipi2 = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Evrak Tipi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Evrak Tipi'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Masraf Merkezi'
        this.snackbar = true
      }
    })

    // this.$http.post(auth.API_URL + 'api/Reference/List', params, {
    //   headers: {
    //     'Authorization': 'Bearer ' + auth.getAuthHeader()
    //   }
    // }).then((response) => {
    //   this.Referans = response.body
    // }, (response) => {
    //   if (response.status === 0) {
    //     this.text1 = 'Service Unavailable-Referans'
    //     this.snackbar = true
    //   } else {
    //     this.text1 = 'Service Unavailable-Referans'
    //     this.snackbar = true
    //   }
    // })


    this.$http.post(auth.API_URL + 'api/Parameters/Get', null, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

      this.Movement.TaxRate = parseFloat(response.body.KdvOran)
    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true

      }
    })

    this.karsicari = false
  
    
  }
</script>

<style>
</style>